import { Component } from 'react';
import I18n from 'I18n';
import { ChatWidgetLocaleContextConsumer } from '../../visitor-widget/ChatWidgetLocaleContext';
import VizExExpandingInput from 'visitor-ui-component-library/input/VizExExpandingInput';
import { jsx as _jsx } from "react/jsx-runtime";
class TextInputPreview extends Component {
  render() {
    return /*#__PURE__*/_jsx(ChatWidgetLocaleContextConsumer, {
      children: locale => /*#__PURE__*/_jsx(VizExExpandingInput, {
        className: "widget-textarea message-box",
        tabIndex: 0,
        maxHeight: 100,
        placeholder: I18n.text('conversations-visitor-experience-components.chatTextArea.placeholder', {
          locale
        }),
        use: "unstyled",
        disabled: true,
        "data-test-id": "input-preview-viz-ex-input"
      })
    });
  }
}
TextInputPreview.displayName = 'TextInputPreview';
export default TextInputPreview;